import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'box-container',
    templateUrl: './box-container.component.html',
    styleUrls: ['./box-container.component.scss'],
    standalone: false
})
export class BoxContainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
